import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-address-lable-mobile-no-english',
  standalone: false,
  templateUrl: './address-lable-mobile-no-english.component.html',
  styleUrl: './address-lable-mobile-no-english.component.scss'
})
export class AddressLableMobileNoEnglishComponent implements OnInit {
  labelsData = [];
  tempdata = [];
  data1 = [];
  today = new Date();
  iscustomer: any;
  isIds: any;
  shortName = {
    वार्षिक: 'वा.',
    त्रैवार्षिक: 'त्रै.',
    पंचवार्षिक: 'पंच.',
    लोकनेता_गंथयात्री_वार्षिक: 'लो.गं.वा.',
    लोकमान्य_ग्रंथयात्री_वार्षिक_वर्गणी: 'लो.ग्रं.वा.व.',
    हिंदुत्व_ग्रंथयात्री: 'हिं.ग्रं.',
    हिंदुत्व_2: 'हिं.2.',
    रामसेवक_ग्रंथयात्री: 'रा.ग्रं.',
  };

  barcodeForm: FormGroup;
  // magzineIdName: any;
  constructor(
    private dialogref: MatDialogRef<AddressLableMobileNoEnglishComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public service: DigisubservicesService,
    public dialog: MatDialog,
    private datePipe: DatePipe) {

    this.barcodeForm = this.fb.group({
      weight: [''],
      senderId: [''],
      postalCodes: ['']
    });
  }
  postalCodes: any = []
  weight: any
  senderId: any
  saveStatus: any
  issue_date: any
  stateName: any
  districtName: any
  talukaName: any
  pincode: any
    rep:any
    officerep:any
    delivery_mode_name:any
    // magzineMasterIDSData: any;
    magzineMasterIDSData: any[] = [];
magzineIdName: string = '';
subname: any
excelMagzineMasterData: any[] = [];
delivery_Mode: any;
disrep: any

  ngOnInit(): void {
    debugger
    this.postalCodes = [];
    this.labelsData = []
    this.labelsData = this.data['addresslabels'];
    this.saveStatus = this.data['saveStatus'];
    console.log("data1=" + this.labelsData);
    this.iscustomer = this.data['iscustomer'];
    this.isIds = this.data['isIds'];
    this.postalCodes = this.data['postalCodes'];
    this.senderId = this.data['senderId'];
    this.weight = this.data['weight'];
    this.issue_date = this.data['issue_date'];
    this.stateName = this.data['stateName'] || [],
      this.districtName = this.data['districtName'] || [],
      this.talukaName = this.data['talukaName'] || [],
      this.pincode = this.data['pincode'],

    this.rep = this.data['rep'] || [],
    this.officerep = this.data['officerep'] || [],
    this.delivery_mode_name = this.data['delivery_mode_name'] || [],
    this.subname = this.data['subname'] || [],
    this.magzineIdName = this.data['magzineIdName'] || [],
    this.disrep = this.data['disrep'] || [],

      this.tempdata = this.uniqueid(this.labelsData, (a) => a['district']);
    if (this.saveStatus == "ADD") {
      this.getBarcodeList1();
    } else {
      this.getBarcodeList();
    }

// Load Magazine ID only when IDS = Yes - Dynamic
if (
  this.isIds &&
  this.isIds.toString().trim().toUpperCase() === 'YES'
) {

  this.service.getAllMagzineIdMasterData().subscribe((res: any) => {

    this.magzineMasterIDSData = res || [];

    let selectedMagzineId = '';

    if (this.magzineMasterIDSData.length > 0) {

      const selectedDeliveryMode =
        this.delivery_mode_name?.toString().trim();

      // Dynamic search based on selected delivery mode
      const selectedRecord = this.magzineMasterIDSData.find(
        (x: any) =>
          x.delivery_Mode &&
          x.delivery_Mode.toString().trim() === selectedDeliveryMode
      );

      // If matching delivery mode found
      if (selectedRecord) {
        selectedMagzineId = selectedRecord.id_Name;
      }
      // Keep old fallback logic
      else {
        selectedMagzineId = this.magzineMasterIDSData[0].id_Name;
      }

      this.magzineIdName = selectedMagzineId;

      // Assign to all label records
      this.data1.forEach((item: any) => {
        item.magzineIdName = selectedMagzineId;
      });

    }

  });

  // Excel Delivery Mode wise data get 
  this.service.getExcelAllMagzineMasterData().subscribe((res: any[]) => {

  const selectedDeliveryMode = this.delivery_mode_name;

  this.excelMagzineMasterData = res.filter((item: any) => {

    const modes = item.delivery_mode_name
      ? item.delivery_mode_name.split(',').map((x: string) => x.trim())
      : [];

    return modes.includes(selectedDeliveryMode)
      || modes.includes('All')
      || modes.includes('all');
  });

});

}



  }
  showModal = false;

  // sortDataDistrictwise() {
  //   for (let index = 0; index < Object.keys(this.tempdata).length; index++) {
  //     let data = this.labelsData.filter(
  //       (a) => a['district'] == this.tempdata[index]['district']
  //     );

  //     // this.tempdata.push({ index: data });
  //     this.data1.push(data);
  //   }
  //   // console.log(this.data1);
  //   // console.log(this.tempdata);
  // }


  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  exportExcel() {
    debugger
    const filteredData = this.data1.map((item, index) => ({
      [this.excelNameJson.srno]: index + 1,
      [this.excelNameJson.barcode]: item.postalCode,
      [this.excelNameJson.physicalWeight]: item.weight == undefined ? item.WEIGT : item.weight,
      // [this.excelNameJson.srno]: item.subno,
      [this.excelNameJson.city]: item.e_district,
      [this.excelNameJson.picode]: item.pincode,
      [this.excelNameJson.name]: item.e_name,
      [this.excelNameJson.address1]: item.e_address,
      [this.excelNameJson.address2]: item.e_address1,
      [this.excelNameJson.address3]: item.e_address2 + " " + item.e_taluka,
      [this.excelNameJson.ack]: "",
      // ADDREMAIL: '',
      [this.excelNameJson.sendermobile]: item.SENDER_MOBILE_NUMBER == undefined ? item.senderId : item.SENDER_MOBILE_NUMBER,
      [this.excelNameJson.recievermobile]: item.mobileNumber,
      [this.excelNameJson.paymentcode]: "",
      [this.excelNameJson.valueofpayment]: "",
      [this.excelNameJson.cod]: "",
      [this.excelNameJson.valuecod]: "",
      [this.excelNameJson.insuranceType]: "",
      [this.excelNameJson.valueOfInsurance]: "",
      [this.excelNameJson.shapeOfArticle]: "",
      [this.excelNameJson.length]: "",
      [this.excelNameJson.breadth]: "",
      [this.excelNameJson.height]: "",
      [this.excelNameJson.priorityFlag]: "",
      [this.excelNameJson.deliveryInstruction]: "",
      [this.excelNameJson.deliverySlot]: "",
      [this.excelNameJson.instructionRTS]: "",
      [this.excelNameJson.senderName]: "",
      [this.excelNameJson.senderCompany]: "",
      [this.excelNameJson.senderCity]: "",
      [this.excelNameJson.senderState]: "",
      [this.excelNameJson.senderPincode]: "",
      [this.excelNameJson.senderEmail]: "",
      [this.excelNameJson.senderAltContact]: "",
      [this.excelNameJson.senderKYC]: "",
      [this.excelNameJson.senderTax]: "",
      [this.excelNameJson.receiverCompany]: "",
      [this.excelNameJson.receiverState]: "",
      [this.excelNameJson.receiverEmail]: "",
      [this.excelNameJson.receiverAltContact]: "",
      [this.excelNameJson.receiverKYC]: "",
      [this.excelNameJson.receiverTaxRef]: "",
      [this.excelNameJson.altAddressFlag]: "",
      [this.excelNameJson.bulkReference]: "",
      [this.excelNameJson.senderAddLine1]: "",
      [this.excelNameJson.senderAddLine2]: "",
      [this.excelNameJson.senderAddLine3]: ""


    }));
    const dateTime = new Date();
    const formatted = this.datePipe.transform(this.issue_date, 'dd-MM-yyyy');

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(blob, formatted + "_Magzine_Post" +'-BARCODE.xlsx');
  }

   exportExcelForPost() {
    debugger
    const filteredData = this.data1.map((item, index) => ({
         
    "SERIAL NUMBER": index + 1,
    "NAME OF SENDER": "Saptahik Vivek",
    "SENDER ADDRESS": "16-119, Shilpin Centre, 1st Floor, 40, G.D. Ambekar Marg, Wadala, Mumbai",
    "SENDER PINCODE": "400031",
    "NAME OF RECEIVER": item.e_name,
    "RECEIVER ADDRESS": item.receiver_address + "," + item.e_taluka + "," + item.e_district,
    "RECEIVER PINCODE": item.pincode,
    "ARTICLE BARCODE": item.postalCode,
    // "BULK REFERENCE": "1234"
    "BULK REFERENCE": item.subno

  }));
    const dateTime = new Date();
    const formatted = this.datePipe.transform(this.issue_date, 'dd-MM-yyyy');

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(blob, formatted + "_Post_Excel" +'-BARCODE.xlsx');
  }

   exportExcelAll() {
    debugger
    const filteredData = this.data1.map((item, index) => ({
      [this.excelNameJson.srno]: index + 1,
      [this.excelNameJson.barcode]: item.postalCode,
      [this.excelNameJson.physicalWeight]: item.weight == undefined ? item.WEIGT : item.weight,
      // [this.excelNameJson.srno]: item.subno,
      [this.excelNameJson.city]: item.e_district,
      [this.excelNameJson.picode]: item.pincode,
      [this.excelNameJson.name]: item.e_name,
      [this.excelNameJson.address1]: item.e_address,
      [this.excelNameJson.address2]: item.e_address1,
      [this.excelNameJson.address3]: item.e_address2 + " " + item.e_taluka,
      [this.excelNameJson.ack]: "",
      // ADDREMAIL: '',
      [this.excelNameJson.sendermobile]: item.SENDER_MOBILE_NUMBER == undefined ? item.senderId : item.SENDER_MOBILE_NUMBER,
      [this.excelNameJson.recievermobile]: item.mobileNumber,
      [this.excelNameJson.paymentcode]: "",
      [this.excelNameJson.valueofpayment]: "",
      [this.excelNameJson.cod]: "",
      [this.excelNameJson.valuecod]: "",
      [this.excelNameJson.insuranceType]: "",
      [this.excelNameJson.valueOfInsurance]: "",
      [this.excelNameJson.shapeOfArticle]: "",
      [this.excelNameJson.length]: "",
      [this.excelNameJson.breadth]: "",
      [this.excelNameJson.height]: "",
      [this.excelNameJson.priorityFlag]: "",
      [this.excelNameJson.deliveryInstruction]: "",
      [this.excelNameJson.deliverySlot]: "",
      [this.excelNameJson.instructionRTS]: "",
      [this.excelNameJson.senderName]: "",
      [this.excelNameJson.senderCompany]: "",
      [this.excelNameJson.senderCity]: "",
      [this.excelNameJson.senderState]: "",
      [this.excelNameJson.senderPincode]: "",
      [this.excelNameJson.senderEmail]: "",
      [this.excelNameJson.senderAltContact]: "",
      [this.excelNameJson.senderKYC]: "",
      [this.excelNameJson.senderTax]: "",
      [this.excelNameJson.receiverCompany]: "",
      [this.excelNameJson.receiverState]: "",
      [this.excelNameJson.receiverEmail]: "",
      [this.excelNameJson.receiverAltContact]: "",
      [this.excelNameJson.receiverKYC]: "",
      [this.excelNameJson.receiverTaxRef]: "",
      [this.excelNameJson.altAddressFlag]: "",
      [this.excelNameJson.bulkReference]: "",
      [this.excelNameJson.senderAddLine1]: "",
      [this.excelNameJson.senderAddLine2]: "",
      [this.excelNameJson.senderAddLine3]: ""


    }));
    const dateTime = new Date();
    const formatted = this.datePipe.transform(this.issue_date, 'dd-MM-yyyy');

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(blob, formatted + "_All_Excel" +'-BARCODE.xlsx');
  }

  saveBarcodeData() {
    console.log(this.data1)
    // this.exportExcel();
  }

exportExcelForPost1() {

  // Arrange columns as per master sequence
  this.excelMagzineMasterData.sort(
    (a: any, b: any) =>
      Number(a.srno || a.sequence_no || a.id || 0) -
      Number(b.srno || b.sequence_no || b.id || 0)
  );

  const fieldMapping: any = {

    srno: (item: any, index: number) => index + 1,

    senderName: () => 'Saptahik Vivek',

    senderAddress: () =>
      '16-119, Shilpin Centre, 1st Floor, 40, G.D. Ambekar Marg, Wadala, Mumbai',

    senderPincode: () => '400031',

    name: (item: any) => item.e_name,

    receiverAddress: (item: any) =>
      (item.receiver_address || '') +
      ',' +
      (item.e_taluka || '') +
      ',' +
      (item.e_district || ''),

    picode: (item: any) => item.pincode,

    barcode: (item: any) => item.postalCode,

    bulkReference: (item: any) => item.subno
  };

  const excelData = this.data1.map((row: any, index: number) => {

    const excelRow: any = {};

    this.excelMagzineMasterData.forEach((col: any) => {

      const fieldName = (col.field_Name || '').trim();

      const columnName = (col.col_name || '').trim();

      excelRow[columnName] =
        fieldMapping[fieldName]
          ? fieldMapping[fieldName](row, index)
          : '';

    });

    return excelRow;

  });

  console.log('Post Excel Data =>', excelData);

  const formatted =
    this.datePipe.transform(
      this.issue_date,
      'dd-MM-yyyy'
    );

  const worksheet: XLSX.WorkSheet =
    XLSX.utils.json_to_sheet(excelData);

  const workbook: XLSX.WorkBook = {
    Sheets: { data: worksheet },
    SheetNames: ['data']
  };

  const excelBuffer: any =
    XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

  const blob: Blob = new Blob(
    [excelBuffer],
    {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  );

  FileSaver.saveAs(
    blob,
    formatted + '_Post_Excel-BARCODE.xlsx'
  );
}

  saveSubscriptionBarcodesDataEntry() {
    const filteredData = this.data1.map((item) => ({
      ds_sub_id: "1",
      ds_sub_name: item.name,
      ds_sub_e_name: item.e_name,
      issue_date: this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss'),
      barcode_number: item.postalCode,
      weight: item.weight,
      sender_mobile_number: item.senderId,
      added_date_time: this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss'),
      is_barcode_generated: "Y",
      status: "A",
      issueDate: this.issue_date,
      subno: item.subno,
      delivery_mode: item.delivery_mode,
      // magzineIdName: item.magzineIdName,
      magzineIdName: this.magzineIdName ? `${this.magzineIdName}` : ''
    }));
    console.log(filteredData);
    this.service.saveSubscriptionBarcodesDataEntry(filteredData).subscribe((data) => {
      alert('Barcodes Save Successfully!');

      // this.exportExcel();
    if (this.delivery_mode_name == 'टपाल') {
      this.exportExcelForPost();
      // this.exportExcelForPost1();
    } else if (this.delivery_mode_name == 'मॅगझीन पोस्ट') {
      this.exportExcel();
      // this.generateDynamicExcel();
    }
    });
  }

  // Old Correct Method
  existingBarcodeList: any
  // getBarcodeList() {
  //   debugger
  //   this.data1 = [];
  //   let barCodeString = "";
  //   this.postalCodes.forEach((item: any, index: number) => {
  //     if (index === 0) {
  //       barCodeString = item;
  //     } else {
  //       barCodeString += "," + item;
  //     }
  //   });

  //   const request = {
  //     "barcode_number": barCodeString,
  //     "issue_date": this.issue_date,
  //     "stateName": this.stateName || [],
  //     "districtName": this.districtName || [],
  //     "talukaName": this.talukaName || [],
  //     "pincode": this.pincode,
  //     "rep" : this.rep || [],
  //   "officerep" : this.officerep || [],
  //   "delivery_mode_name" : this.delivery_mode_name || [],
  //   "isIds" : this.isIds || [],
  //   }
  //   console.log(request);
  //   this.service.getBarcodeList(request).subscribe((responseData: any) => {
  //     // alert('Barcodes Save Successfully!');
  //      const sortedData = responseData.data.sort((a: any, b: any) => {
  //   return Number(a.pincode) - Number(b.pincode);
  // });
  //     // this.data1 = responseData.data;
  //     // this.existingBarcodeList = responseData.data;

  //     this.data1 = sortedData;
  //     this.existingBarcodeList = sortedData;

  //   });
  // }

getBarcodeList() {

  debugger;

  this.data1 = [];

  let barCodeString = "";

  this.postalCodes.forEach((item: any, index: number) => {

    if (index === 0) {
      barCodeString = item;
    } else {
      barCodeString += "," + item;
    }

  });

  const request = {
    barcode_number: barCodeString,
    issue_date: this.issue_date,
    stateName: this.stateName || [],
    districtName: this.districtName || [],
    talukaName: this.talukaName || [],
    pincode: this.pincode,
    rep: this.rep || [],
    officerep: this.officerep || [],
    delivery_mode_name: this.delivery_mode_name || [],
    isIds: this.isIds || [],
    subname: this.subname || [],
    disrep: this.disrep || [],
  };

  console.log(request);

  this.service.getBarcodeList(request).subscribe((responseData: any) => {

    const districtOrder: any = {

      'मुंबई': 1,
      'Mumbai': 1,
      'MUMBAI': 1,

      'ठाणे': 2,
      'Thane': 2,
      'THANE': 2,

      'पालघर': 3,
      'Palghar': 3,
      'PALGHAR': 3,

      'रायगड': 4,
      'Raigad': 4,
      'RAIGAD': 4,

      'रत्नागिरी': 5,
      'Ratnagiri': 5,
      'RATNAGIRI': 5,

      'सिंधुदुर्ग': 6,
      'Sindhudurg': 6,
      'SINDHUDURG': 6

    };

    const sortedData = responseData.data.sort((a: any, b: any) => {

      const districtA =
        districtOrder[a.district] || 999;

      const districtB =
        districtOrder[b.district] || 999;

      // Fixed priority districts
      if (districtA !== districtB) {
        return districtA - districtB;
      }

      // Remaining districts grouped district-wise
      if (districtA === 999 && districtB === 999) {

        const districtCompare =
          (a.district || '').localeCompare(
            (b.district || ''),
            'mr'
          );

        if (districtCompare !== 0) {
          return districtCompare;
        }

      }

      // Same district -> pincode ascending
      return Number(a.pincode || 0) -
             Number(b.pincode || 0);

    });

    this.data1 = sortedData;
    this.existingBarcodeList = sortedData;

    console.log(this.data1);

  });

}

// Latest Correct Method
//   getBarcodeList() {
//   debugger

//   this.data1 = [];

//   let barCodeString = "";

//   this.postalCodes.forEach((item: any, index: number) => {
//     if (index === 0) {
//       barCodeString = item;
//     } else {
//       barCodeString += "," + item;
//     }
//   });

//   const request = {
//     "barcode_number": barCodeString,
//     "issue_date": this.issue_date,
//     "stateName": this.stateName || [],
//     "districtName": this.districtName || [],
//     "talukaName": this.talukaName || [],
//     "pincode": this.pincode,
//     "rep": this.rep || [],
//     "officerep": this.officerep || [],
//     "delivery_mode_name": this.delivery_mode_name || [],
//     "isIds": this.isIds || [],
//   }

//   console.log(request);

//   this.service.getBarcodeList(request).subscribe((responseData: any) => {

//     const districtOrder: any = {
//       'मुंबई': 1,
//       'Mumbai': 1,
//       'MUMBAI': 1,

//       'ठाणे': 2,
//       'Thane': 2,
//       'THANE': 2,

//       'पालघर': 3,
//       'Palghar': 3,
//       'PALGHAR': 3,

//       'रायगड': 4,
//       'Raigad': 4,
//       'RAIGAD': 4,

//       'रत्नागिरी': 5,
//       'Ratnagiri': 5,
//       'RATNAGIRI': 5,

//       'सिंधुदुर्ग': 6,
//       'Sindhudurg': 6,
//       'SINDHUDURG': 6

//     };

//     const sortedData = responseData.data.sort((a: any, b: any) => {

//       const districtA = districtOrder[a.district] || 999;
//       const districtB = districtOrder[b.district] || 999;

//       if (districtA !== districtB) {
//         return districtA - districtB;
//       }

//       return Number(a.pincode || 0) - Number(b.pincode || 0);

//     });

//     this.data1 = sortedData;
//     this.existingBarcodeList = sortedData;

//   });
// }

  // Old Correct Method
//   getBarcodeList1() {
//     debugger
//     if (this.postalCodes.length != this.labelsData.length) {
//       alert("Postal Code and Tickets Are Not Same !! Postal Codes are=" + this.postalCodes.length + " and Tickets Are=" + this.labelsData.length)
//       return;
//     }
//     this.data1 = [];
//     let barCodeString = "";
//     this.postalCodes.forEach((item: any, index: number) => {
//       if (index === 0) {
//         barCodeString = item;
//       } else {
//         barCodeString += "," + item;
//       }
//     });

//     const request = {
//       "barcode_number": barCodeString
//     }
//     console.log(request);
//     this.service.getBarcodeList(request).subscribe((responseData: any) => {
//       // alert('Barcodes Save Successfully!');

//   // Existing barcode list sorted by pincode
//     // this.existingBarcodeList = responseData.data.sort((a: any, b: any) => {
//     //   return Number(a.pincode) - Number(b.pincode);
//     // });

//       this.existingBarcodeList = responseData.data;
//       this.existingBarcodeList = responseData.data;

//       let index1 = 0;
//       for (let index = 0; index < Object.keys(this.tempdata).length; index++) {
//         let data = this.labelsData.filter(
//           (a) => a['district'] == this.tempdata[index]['district']
//         );

//         data.map((a) => {
//           a.shortname = this.shortName[a.Subscription_Type.split(' ').join('_')];
//           a.postalCode = this.postalCodes[index1];
//           console.log(index1 + "=" + this.postalCodes[index1])
//           a.senderId = this.senderId;
//           a.weight = this.weight;
//           ++index1;
//         });

//         this.data1.push(data);
//         console.log(this.data1);

//       }
//       let notExistingBarcodeList;
//       if (this.existingBarcodeList != undefined) {
//         notExistingBarcodeList = this.existingBarcodeList.filter(item =>
//           this.data1.includes(item.postalCode)
//         );
//         if (notExistingBarcodeList.length != 0 && notExistingBarcodeList != undefined) {
//           // alert("Already Ticket Gene");
//           this.data1 = []
//         } else {
//           let notExistingBarcodeList1 = this.existingBarcodeList.filter(item =>
//             !this.data1.includes(item.postalCode)
//           );
//           alert(notExistingBarcodeList1.length + " Tickets Are Pending and barcode" + this.postalCodes.length);
//           this.data1 = notExistingBarcodeList1;
//         }


//       }



//       let data = []
//       this.data1.forEach(element => {
//         element.forEach(data2 => {
//           data.push(data2)
//         });

//       });

//  // Final sorting by pincode ascending
//     // data.sort((a: any, b: any) => {
//     //   return Number(a.postalCode || a.pincode) -
//     //          Number(b.postalCode || b.pincode);
//     // });

//       this.data1 = data
//       // this.exportToExcel(this.data1);

//       // if (this.data1.length <= 4) {
//       //   const requiredLength = 5;
//       //   const numberOfItemsToAdd = requiredLength - this.data1.length;

//       //   for (let i = 0; i < numberOfItemsToAdd; i++) {
//       //     this.data1.push({
//       //       shortname: '',
//       //       month: '',
//       //       subno: '',
//       //       year: '',
//       //       title: '',
//       //       name: '',
//       //       address: '',
//       //       taluka: '',
//       //       district: '',
//       //       pincode: '',
//       //       state: ''
//       //     });
//       //   }
//       // }
//     });
//   }

// Latest Correct Method
// getBarcodeList1() {

//   debugger;

//   if (this.postalCodes.length != this.labelsData.length) {

//     alert(
//       "Postal Code and Tickets Are Not Same !! Postal Codes are=" +
//       this.postalCodes.length +
//       " and Tickets Are=" +
//       this.labelsData.length
//     );

//     return;
//   }

//   this.data1 = [];

//   let barCodeString = "";

//   this.postalCodes.forEach((item: any, index: number) => {

//     if (index === 0) {
//       barCodeString = item;
//     } else {
//       barCodeString += "," + item;
//     }

//   });

//   const request = {
//     "barcode_number": barCodeString
//   };

//   console.log(request);

//   this.service.getBarcodeList(request).subscribe((responseData: any) => {

//     this.existingBarcodeList = responseData.data;
//     this.existingBarcodeList = responseData.data;

//     let index1 = 0;

//     // ✅ ONLY CHANGE
//     // SORT tempdata PINCODE WISE

//     this.tempdata.sort((a: any, b: any) => {
//       return Number(a.pincode || 0) - Number(b.pincode || 0);
//     });

//     for (
//       let index = 0;
//       index < Object.keys(this.tempdata).length;
//       index++
//     ) {

//       let data = this.labelsData.filter(
//         (a) => a['district'] == this.tempdata[index]['district']
//       );

//       // ✅ ONLY CHANGE
//       // SORT DATA PINCODE WISE

//       data.sort((a: any, b: any) => {
//         return Number(a.pincode || 0) - Number(b.pincode || 0);
//       });

//       data.map((a: any) => {

//         a.shortname =
//           this.shortName[
//             a.Subscription_Type.split(' ').join('_')
//           ];

//         a.postalCode = this.postalCodes[index1];

//         console.log(
//           index1 + "=" + this.postalCodes[index1]
//         );

//         a.senderId = this.senderId;
//         a.weight = this.weight;

//         ++index1;

//       });

//       this.data1.push(data);

//       console.log(this.data1);

//     }

//     let notExistingBarcodeList;

//     if (this.existingBarcodeList != undefined) {

//       notExistingBarcodeList =
//         this.existingBarcodeList.filter(item =>
//           this.data1.includes(item.postalCode)
//         );

//       if (
//         notExistingBarcodeList.length != 0 &&
//         notExistingBarcodeList != undefined
//       ) {

//         // alert("Already Ticket Gene");
//         this.data1 = [];

//       } else {

//         let notExistingBarcodeList1 =
//           this.existingBarcodeList.filter(item =>
//             !this.data1.includes(item.postalCode)
//           );

//         alert(
//           notExistingBarcodeList1.length +
//           " Tickets Are Pending and barcode" +
//           this.postalCodes.length
//         );

//         this.data1 = notExistingBarcodeList1;

//       }

//     }

//     let data: any[] = [];

//     this.data1.forEach((element: any) => {

//       element.forEach((data2: any) => {

//         data.push(data2);

//       });

//     });

//     // ✅ ONLY CHANGE
//     // FINAL SORTING BY PINCODE

//     data.sort((a: any, b: any) => {
//       return Number(a.pincode || 0) - Number(b.pincode || 0);
//     });

//     this.data1 = data;

//     console.log(this.data1);

//     // this.exportToExcel(this.data1);

//     // if (this.data1.length <= 4) {
//     //   const requiredLength = 5;
//     //   const numberOfItemsToAdd = requiredLength - this.data1.length;

//     //   for (let i = 0; i < numberOfItemsToAdd; i++) {
//     //     this.data1.push({
//     //       shortname: '',
//     //       month: '',
//     //       subno: '',
//     //       year: '',
//     //       title: '',
//     //       name: '',
//     //       address: '',
//     //       taluka: '',
//     //       district: '',
//     //       pincode: '',
//     //       state: ''
//     //     });
//     //   }
//     // }

//   });

// }
  
// Old Correct Code 
// getBarcodeList1() {

//   debugger;

//   if (this.postalCodes.length != this.labelsData.length) {

//     alert(
//       "Postal Code and Tickets Are Not Same !! Postal Codes are=" +
//       this.postalCodes.length +
//       " and Tickets Are=" +
//       this.labelsData.length
//     );

//     return;
//   }

//   this.data1 = [];

//   let barCodeString = "";

//   this.postalCodes.forEach((item: any, index: number) => {

//     if (index === 0) {
//       barCodeString = item;
//     } else {
//       barCodeString += "," + item;
//     }

//   });

//   const request = {
//     barcode_number: barCodeString
//   };

//   console.log(request);

//   this.service.getBarcodeList(request).subscribe((responseData: any) => {

//     this.existingBarcodeList = responseData.data;
//     this.existingBarcodeList = responseData.data;

//     let index1 = 0;

//     for (
//       let index = 0;
//       index < Object.keys(this.tempdata).length;
//       index++
//     ) {

//       let data = this.labelsData.filter(
//         (a) => a['district'] == this.tempdata[index]['district']
//       );

//       data.sort((a: any, b: any) => {
//         return Number(a.pincode || 0) - Number(b.pincode || 0);
//       });

//       data.map((a: any) => {

//         a.shortname =
//           this.shortName[
//           a.Subscription_Type.split(' ').join('_')
//           ];

//         a.postalCode = this.postalCodes[index1];

//         console.log(
//           index1 + "=" + this.postalCodes[index1]
//         );

//         a.senderId = this.senderId;
//         a.weight = this.weight;

//         ++index1;

//       });

//       this.data1.push(data);

//       console.log(this.data1);

//     }

//     let notExistingBarcodeList;

//     if (this.existingBarcodeList != undefined) {

//       notExistingBarcodeList =
//         this.existingBarcodeList.filter(item =>
//           this.data1.includes(item.postalCode)
//         );

//       if (
//         notExistingBarcodeList.length != 0 &&
//         notExistingBarcodeList != undefined
//       ) {

//         this.data1 = [];

//       } else {

//         let notExistingBarcodeList1 =
//           this.existingBarcodeList.filter(item =>
//             !this.data1.includes(item.postalCode)
//           );

//         alert(
//           notExistingBarcodeList1.length +
//           " Tickets Are Pending and barcode" +
//           this.postalCodes.length
//         );

//         this.data1 = notExistingBarcodeList1;

//       }

//     }

//     let data: any[] = [];

//     this.data1.forEach((element: any) => {

//       element.forEach((data2: any) => {

//         data.push(data2);

//       });

//     });

//     // DISTRICT WISE + PINCODE WISE SORTING

//     const districtOrder: any = {
//       'मुंबई': 1,
//       'MUMBAI': 1,
//       'Mumbai': 1,

//       'ठाणे': 2,
//       'THANE': 2,
//       'Thane': 2
//     };

//     data.sort((a: any, b: any) => {

//       const districtA =
//         districtOrder[a.district] || 999;

//       const districtB =
//         districtOrder[b.district] || 999;

//       if (districtA !== districtB) {
//         return districtA - districtB;
//       }

//       return Number(a.pincode || 0) -
//         Number(b.pincode || 0);

//     });

//     this.data1 = data;

//     console.log(this.data1);

//     // this.exportToExcel(this.data1);

//     // if (this.data1.length <= 4) {
//     //   const requiredLength = 5;
//     //   const numberOfItemsToAdd = requiredLength - this.data1.length;

//     //   for (let i = 0; i < numberOfItemsToAdd; i++) {
//     //     this.data1.push({
//     //       shortname: '',
//     //       month: '',
//     //       subno: '',
//     //       year: '',
//     //       title: '',
//     //       name: '',
//     //       address: '',
//     //       taluka: '',
//     //       district: '',
//     //       pincode: '',
//     //       state: ''
//     //     });
//     //   }
//     // }

//   });

// }

getBarcodeList1() {

  debugger;

  if (this.postalCodes.length != this.labelsData.length) {

    alert(
      "Postal Code and Tickets Are Not Same !! Postal Codes are=" +
      this.postalCodes.length +
      " and Tickets Are=" +
      this.labelsData.length
    );

    return;
  }

  this.data1 = [];

  let barCodeString = "";

  this.postalCodes.forEach((item: any, index: number) => {

    if (index === 0) {
      barCodeString = item;
    } else {
      barCodeString += "," + item;
    }

  });

  const request = {
    barcode_number: barCodeString
  };

  console.log(request);

  this.service.getBarcodeList(request).subscribe((responseData: any) => {

    this.existingBarcodeList = responseData.data;
    this.existingBarcodeList = responseData.data;

    let index1 = 0;

    for (
      let index = 0;
      index < Object.keys(this.tempdata).length;
      index++
    ) {

      let data = this.labelsData.filter(
        (a) => a['district'] == this.tempdata[index]['district']
      );

      data.sort((a: any, b: any) => {
        return Number(a.pincode || 0) - Number(b.pincode || 0);
      });

      data.map((a: any) => {

        a.shortname =
          this.shortName[
            a.Subscription_Type.split(' ').join('_')
          ];

        a.postalCode = this.postalCodes[index1];

        console.log(
          index1 + "=" + this.postalCodes[index1]
        );

        a.senderId = this.senderId;
        a.weight = this.weight;

        ++index1;

      });

      this.data1.push(data);

      console.log(this.data1);

    }

    let notExistingBarcodeList;

    if (this.existingBarcodeList != undefined) {

      notExistingBarcodeList =
        this.existingBarcodeList.filter(item =>
          this.data1.includes(item.postalCode)
        );

      if (
        notExistingBarcodeList.length != 0 &&
        notExistingBarcodeList != undefined
      ) {

        this.data1 = [];

      } else {

        let notExistingBarcodeList1 =
          this.existingBarcodeList.filter(item =>
            !this.data1.includes(item.postalCode)
          );

        alert(
          notExistingBarcodeList1.length +
          " Tickets Are Pending and barcode " +
          this.postalCodes.length
        );

        this.data1 = notExistingBarcodeList1;

      }

    }

    let data: any[] = [];

    this.data1.forEach((element: any) => {

      element.forEach((data2: any) => {

        data.push(data2);

      });

    });

    // ==========================================
    // DISTRICT WISE + PINCODE WISE SORTING
    // ==========================================

    const districtOrder: any = {

      'मुंबई': 1,
      'MUMBAI': 1,
      'Mumbai': 1,

      'ठाणे': 2,
      'THANE': 2,
      'Thane': 2

    };

    data.sort((a: any, b: any) => {

      const districtA =
        districtOrder[a.district] || 999;

      const districtB =
        districtOrder[b.district] || 999;

      // Mumbai first, Thane second
      if (districtA !== districtB) {
        return districtA - districtB;
      }

      // Other districts grouped district-wise
      if (districtA === 999 && districtB === 999) {

        const districtCompare =
          (a.district || '').localeCompare(
            (b.district || ''),
            'mr'
          );

        if (districtCompare !== 0) {
          return districtCompare;
        }

      }

      // Same district -> pincode ascending
      return Number(a.pincode || 0) -
             Number(b.pincode || 0);

    });

    this.data1 = data;

    console.log(this.data1);

    // this.exportToExcel(this.data1);

  });

}

  //Old Method
  // paginatedData(): any[][][] {
  //   debugger
  //   const perPage = 16;
  //   const perRow = 4;
  //   const result: any[][][] = [];

  //   for (let i = 0; i < this.data1.length; i += perPage) {
  //     const pageItems = this.data1.slice(i, i + perPage);
  //     const rows: any[][] = [];

  //     for (let j = 0; j < pageItems.length; j += perRow) {
  //       let row = pageItems.slice(j, j + perRow);

  //       // Pad with nulls if row has less than 4 items
  //       while (row.length < perRow) {
  //         row.push(null);
  //       }

  //       rows.push(row);
  //     }

  //     result.push(rows);
  //   }

  //   return result;
  // }

   paginatedData(): any[][][] {
    //debugger
    const perPage = 18;
    const perRow = 3;
    const result: any[][][] = [];

     // Add magazine ID to each item
  // const dataWithMagazineId = this.data1.map(item => ({
  //   ...item,
  //   magzineIdName: this.magzineIdName
  // }));

  const dataWithMagazineId = this.data1.map(item => ({
  ...item,
  magzineIdName:
    this.isIds &&
    this.isIds.toString().trim().toUpperCase() === 'YES'
      ? this.magzineIdName
      : ''
}));

    // for (let i = 0; i < this.data1.length; i += perPage) {
    //   const pageItems = this.data1.slice(i, i + perPage);

    for (let i = 0; i < dataWithMagazineId.length; i += perPage) {

  const pageItems = dataWithMagazineId.slice(i, i + perPage);

      const rows: any[][] = [];

      for (let j = 0; j < pageItems.length; j += perRow) {
        let row = pageItems.slice(j, j + perRow);

        // Pad with nulls if row has less than 4 items
        while (row.length < perRow) {
          row.push(null);
        }

        rows.push(row);
      }

      result.push(rows);
    }

    return result;
  }

  excelNameJson = {
    "srno": "SERIAL NUMBER",
    "barcode": "BARCODE NO",
    "physicalWeight": "PHYSICAL WEIGHT",
    "city": "RECEIVER CITY",
    "picode": "RECEIVER PINCODE",
    "name": "RECEIVER NAME",
    "address1": "RECEIVER ADD LINE 1",
    "address2": "RECEIVER ADD LINE 2",
    "address3": "RECEIVER ADD LINE 3",
    "ack": "ACK",
    "sendermobile": "SENDER MOBILE NO",
    "recievermobile": "RECEIVER MOBILE NO",
    "paymentcode": "PREPAYMENT CODE",
    "valueofpayment": "VALUE OF PREPAYMENT",
    "cod": "CODR/COD",
    "valuecod": "VALUE FOR CODR/COD",

    "insuranceType": "INSURANCE TYPE",
    "valueOfInsurance": "VALUE OF INSURANCE",
    "shapeOfArticle": "SHAPE OF ARTICLE",
    "length": "LENGTH",
    "breadth": "BREADTH/DIAMETER",
    "height": "HEIGHT",
    "priorityFlag": "PRIORITY FLAG",
    "deliveryInstruction": "DELIVERY INSTRUCTION",
    "deliverySlot": "DELIVERY SLOT",
    "instructionRTS": "INSTRUCTION RTS",
    "senderName": "SENDER NAME",
    "senderCompany": "SENDER COMPANY NAME",
    "senderCity": "SENDER CITY",
    "senderState": "SENDER STATE/UT",
    "senderPincode": "SENDER PINCODE",
    "senderEmail": "SENDER EMAILID",
    "senderAltContact": "SENDER ALT CONTACT",
    "senderKYC": "SENDER KYC",
    "senderTax": "SENDER TAX",
    "receiverCompany": "RECEIVER COMPANY NAME",
    "receiverState": "RECEIVER STATE/UT",
    "receiverEmail": "RECEIVER EMAILID",
    "receiverAltContact": "RECEIVER ALT CONTACT",
    "receiverKYC": "RECEIVER KYC",
    "receiverTaxRef": "RECEIVER TAX REF",
    "altAddressFlag": "ALT ADDRESS FLAG",
    "bulkReference": "BULK REFERENCE",
    "senderAddLine1": "SENDER ADD LINE 1",
    "senderAddLine2": "SENDER ADD LINE 2",
    "senderAddLine3": "SENDER ADD LINE 3"
  };

   excelNameJsonPost = {
    "srno": "SERIAL NUMBER",
"senderName": "NAME OF SENDER",
// "senderAddLine1": "SENDER ADD LINE 1",
//     "senderAddLine2": "SENDER ADD LINE 2",
//     "senderAddLine3": "SENDER ADD LINE 3",

"senderAddress": "SENDER ADDRESS",
    "senderPincode": "SENDER PINCODE",
    "name": "NAME OF RECEIVER",
    "receiverAddress": "RECEIVER ADDRESS",


    // "address1": "RECEIVER ADD LINE 1",
    // "address2": "RECEIVER ADD LINE 2",
    // "address3": "RECEIVER ADD LINE 3",

    "picode": "RECEIVER PINCODE",
    "barcode": "ARTICLE BARCODE",
    "bulkReference": "BULK REFERENCE",

  };

  //Dyanamic Excel Auto Download
generateDynamicExcel() {

  this.service.getExcelAllMagzineMasterData().subscribe((res: any[]) => {

    const selectedDeliveryMode =
      (this.delivery_mode_name || '').toString().trim();

    this.excelMagzineMasterData = res.filter((item: any) => {

      const modes = item.delivery_mode_name
        ? item.delivery_mode_name
            .split(',')
            .map((x: string) => x.trim())
        : [];

      return (
        modes.includes(selectedDeliveryMode) ||
        modes.includes('All') ||
        modes.includes('all')
      );

    });

    // Column Sequence Order From Master Table
    this.excelMagzineMasterData.sort(
      (a: any, b: any) =>
        Number(a.srno || a.sequence_no || a.id || 0) -
        Number(b.srno || b.sequence_no || b.id || 0)
    );

    console.log('Selected Delivery Mode =>', selectedDeliveryMode);
    console.log('Excel Master Data =>', this.excelMagzineMasterData);
    console.log('Excel Row Data =>', this.data1);

    if (
      !this.excelMagzineMasterData ||
      this.excelMagzineMasterData.length === 0
    ) {
      alert(
        'No Excel Master Columns Found For Delivery Mode : ' +
        selectedDeliveryMode
      );
      return;
    }

    const fieldMapping: any = {

      srno: (item: any, index: number) => index + 1,

      barcode: (item: any) => item.postalCode,

      physicalWeight: (item: any) =>
        item.weight == undefined ? item.WEIGT : item.weight,

      city: (item: any) => item.e_district,

      picode: (item: any) => item.pincode,

      name: (item: any) => item.e_name,

      address1: (item: any) => item.e_address,

      address2: (item: any) => item.e_address1,

      address3: (item: any) =>
        (item.e_address2 || '') + ' ' + (item.e_taluka || ''),

      ack: () => '',

      sendermobile: (item: any) =>
        item.SENDER_MOBILE_NUMBER == undefined
          ? item.senderId
          : item.SENDER_MOBILE_NUMBER,

      recievermobile: (item: any) => item.mobileNumber,

      paymentcode: () => '',
      valueofpayment: () => '',
      cod: () => '',
      valuecod: () => '',
      insuranceType: () => '',
      valueOfInsurance: () => '',
      shapeOfArticle: () => '',
      length: () => '',
      breadth: () => '',
      height: () => '',
      priorityFlag: () => '',
      deliveryInstruction: () => '',
      deliverySlot: () => '',
      instructionRTS: () => '',

      senderName: () => 'Saptahik Vivek',

      senderCompany: () => '',

      senderCity: () => '',

      senderState: () => '',

      senderPincode: () => '400031',

      senderEmail: () => '',

      senderAltContact: () => '',

      senderKYC: () => '',

      senderTax: () => '',

      receiverCompany: () => '',

      receiverState: () => '',

      receiverEmail: () => '',

      receiverAltContact: () => '',

      receiverKYC: () => '',

      receiverTaxRef: () => '',

      altAddressFlag: () => '',

      bulkReference: (item: any) => item.subno,

      senderAddLine1: () => '',

      senderAddLine2: () => '',

      senderAddLine3: () => '',

      receiverAddress: (item: any) =>
        (item.receiver_address || '') +
        ',' +
        (item.e_taluka || '') +
        ',' +
        (item.e_district || ''),

      senderAddress: () =>
        '16-119, Shilpin Centre, 1st Floor, 40, G.D. Ambekar Marg, Wadala, Mumbai'
    };

    const excelData = this.data1.map((row: any, index: number) => {

      const excelRow: any = {};

      this.excelMagzineMasterData.forEach((col: any) => {

        const fieldName =
          (col.field_Name || '').toString().trim();

        const columnName =
          (col.col_name || '').toString().trim();

        excelRow[columnName] =
          fieldMapping[fieldName]
            ? fieldMapping[fieldName](row, index)
            : '';

      });

      return excelRow;

    });

    console.log('Generated Excel Data =>', excelData);

    const worksheet: XLSX.WorkSheet =
      XLSX.utils.json_to_sheet(excelData);

    const workbook: XLSX.WorkBook = {
      Sheets: {
        data: worksheet
      },
      SheetNames: ['data']
    };

    const excelBuffer: any = XLSX.write(
      workbook,
      {
        bookType: 'xlsx',
        type: 'array'
      }
    );

    const blob: Blob = new Blob(
      [excelBuffer],
      {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    );

    const formatted =
      this.datePipe.transform(
        this.issue_date,
        'dd-MM-yyyy'
      );

    FileSaver.saveAs(
      blob,
      formatted + '_Magzine_Post-BARCODE.xlsx'
    );

  });

}
}

